module.exports = __webpack_public_path__ + "static/media/close.080cd4a5.svg";